function getFriendlyTime(time) {
  var hourShipTextSplit = time.split(':');
  var hourShipHour = parseInt(hourShipTextSplit[0]) || 16;
  var hourShipMinute = hourShipTextSplit[1] || '00';
  var suffix = hourShipHour <= 11 ? 'AM' : 'PM';
  x = ((hourShipHour + 11) % 12) + 1 + ':' + hourShipMinute + ' ' + suffix;
  return x;
}

function independentGetDate(daySelected) {
  var monthArray = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  var localDate = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }),
  );
  if (daySelected == 'tomorrow') {
    var usersCurrentSetDate = localDate.setDate(localDate.getDate() + 1);
  } else {
    var usersCurrentSetDate = localDate.setDate(localDate.getDate());
  }
  var usersCurrentDate = new Date(usersCurrentSetDate);
  var usersCurrentDateMonth = monthArray[usersCurrentDate.getMonth()];
  var usersCurrentDateDay = usersCurrentDate.getDate();
  var usersCurrentDateYear = usersCurrentDate.getFullYear();
  var usersCurrentDate = `${usersCurrentDateMonth} ${usersCurrentDateDay}, ${usersCurrentDateYear}`;
  return usersCurrentDate;
}

const getTime = () => {
  // Function to set the shipping estimation date for regular days and holidays
  const dayPlus = (number) => {
    const dayPlusDate = localDate.setDate(localDate.getDate() + number);

    const toDate = new Date(dayPlusDate);
    const toDateMonth = monthArray[toDate.getMonth()];
    const toDateDay = toDate.getDate();
    const toDateDayName = toDate.toLocaleString('en-US', { weekday: 'long' });
    const toDateYear = toDate.getFullYear();
    const toMonth = toDate.getMonth();

    const plusMonthDay = `//${toMonth + 1}, ${toDateDay}//`;
    const datePlus = `${toDateMonth} ${toDateDay}, ${toDateYear}`;

    const ld = new Date(
      new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }),
    );

    const now = ld.getTime();
    const dateAndTimeCutoff = `${datePlus} ${hourShip}`;
    const then = new Date(dateAndTimeCutoff).getTime();
    const distance = then - now;

    const hoursRemaining = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutesRemaining = Math.floor(
      (distance % (1000 * 60 * 60)) / (1000 * 60),
    );
    const secondsRemaining = Math.floor((distance % (1000 * 60)) / 1000);

    const remainingTime = `${hoursRemaining > 0 ? hoursRemaining + (hoursRemaining === 1 ? ' hour' : ' hours') : ''} ${minutesRemaining > 0 && hoursRemaining === 0 ? minutesRemaining + (minutesRemaining === 1 ? ' minute' : ' minutes') : '' + (hoursRemaining === 0 && minutesRemaining === 0 && secondsRemaining > 0 ? secondsRemaining + (secondsRemaining === 1 ? ' second' : ' seconds') : '')}`;

    if (holidays.includes(plusMonthDay) || toDateDayName == 'Saturday') {
      let numberPlus = 1;

      if (toDateDayName == 'Friday') {
        numberPlus = 3;
      }

      if (toDateDayName == 'Saturday') {
        numberPlus = 2;
      }

      const dayPlusDateOne = localDate.setDate(
        localDate.getDate() + numberPlus,
      );

      const toDatePlus = new Date(dayPlusDateOne);

      const toDateDayPlus = toDatePlus.getDate();
      const toDateMonthPlus = monthArray[toDatePlus.getMonth()];
      const toDateYearPlus = toDatePlus.getFullYear();
      const datePlusOne = `${toDateMonthPlus} ${toDateDayPlus}, ${toDateYearPlus}`;

      timeSpan.innerHTML = `${datePlusOne} (Order by ${hourShipText || '4pm'} ET)`;
    } else {
      if (datePlus == independentGetDate('today')) {
        // Shipping date is today's date.  Display "Today".
        timeSpan.innerHTML = `<span class="wwis-day-text">today</span><span class="wwis-punctuation">:</span> <span class="wwis-ow-text">order within <span class="wwis-ow-time">${remainingTime}</span></span>`;
      } else {
        if (datePlus == independentGetDate('tomorrow')) {
          // Shipping date is tomorrow.  Display "Tomorrow".
          timeSpan.innerHTML = `<span class="wwis-day-text">tomorrow</span><span class="wwis-punctuation">:</span> <span class="wwis-ow-text">order within <span class="wwis-ow-time">${remainingTime}</span></span>`;
        } else {
          // Shipping date is further than today or tomorrow - display actual date
          timeSpan.innerHTML = `<span class="wwis-day-text">${datePlus}</span>`;
        }
      }
    }
  };

  // Get related date data from the #shipping-meesage HTML element
  const timeSpan = document.getElementById('shipping-meesage');
  const holidays = document.getElementById('shipping-meesage').dataset.holidays;
  const hourShip =
    document.getElementById('shipping-meesage').dataset.shippingHour;
  const hourShipText = getFriendlyTime(hourShip);

  // Get global Data object data
  const localDate = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }),
  );

  const monthArray = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const weekDay = localDate.toLocaleString('en-US', { weekday: 'long' });
  const hourFormat = localDate.toLocaleTimeString('en-GB');
  const month = localDate.getMonth();
  const day = localDate.getDate();
  const year = localDate.getFullYear();
  const dayMonth = `//${month + 1}, ${day}//`;
  const monthName = monthArray[localDate.getMonth()];

  const bottomDate = `${monthName} ${day}, ${year}`;

  const nowBottom = localDate.getTime();
  const thenBottom = new Date(`${bottomDate} ${hourShip}`).getTime();
  const distanceBottom = thenBottom - nowBottom;

  const hoursRemainingBottom = Math.floor(
    (distanceBottom % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const minutesRemainingBottom = Math.floor(
    (distanceBottom % (1000 * 60 * 60)) / (1000 * 60),
  );
  const secondsRemainingBottom = Math.floor(
    (distanceBottom % (1000 * 60)) / 1000,
  );

  const remainingTimeBottom = `${hoursRemainingBottom > 0 ? hoursRemainingBottom + (hoursRemainingBottom === 1 ? ' hour' : ' hours') : ''} ${minutesRemainingBottom > 0 && hoursRemainingBottom === 0 ? minutesRemainingBottom + (minutesRemainingBottom === 1 ? ' minute' : ' minutes') : '' + (hoursRemainingBottom === 0 && minutesRemainingBottom === 0 && secondsRemainingBottom > 0 ? secondsRemainingBottom + (secondsRemainingBottom === 1 ? ' second' : ' seconds') : '')}`;

  // Set conditions for the shipping calculatation
  if ((weekDay != 'Saturday' || weekDay != 'Sunday') && hourFormat < hourShip) {
    if (holidays.includes(dayMonth)) {
      dayPlus(1);
    } else {
      if (bottomDate == independentGetDate('today')) {
        // Shipping date is today's date.  Display "Today".
        timeSpan.innerHTML = `<span class="wwis-day-text">today</span><span class="wwis-punctuation">:</span> <span class="wwis-ow-text">order within <span class="wwis-ow-time">${remainingTimeBottom}</span></span>`;
      } else {
        if (bottomDate == independentGetDate('tomorrow')) {
          // Shipping date is tomorrow.  Display "Tomorrow".
          timeSpan.innerHTML = `<span class="wwis-day-text">tomorrow</span><span class="wwis-punctuation">:</span> <span class="wwis-ow-text">order within <span class="wwis-ow-time">${remainingTimeBottom}</span></span>`;
        } else {
          // Shipping date is further than today or tomorrow - display actual date
          timeSpan.innerHTML = `<span class="wwis-day-text">${bottomDate}</span>`;
        }
      }
    }
  }

  if (
    (weekDay != 'Saturday' || weekDay != 'Sunday' || weekDay !== 'Friday') &&
    hourFormat > hourShip
  ) {
    dayPlus(1);
  }

  if (weekDay == 'Friday' && hourFormat > hourShip) {
    dayPlus(3);
  }

  if (weekDay == 'Saturday') {
    dayPlus(2);
  }

  if (weekDay == 'Sunday') {
    dayPlus(1);
  }
};

// Run function once the HTML document has been completely parsed
window.addEventListener('DOMContentLoaded', () => {
  setInterval(getTime, 500);
});
